<div *ngIf="data.title" mat-dialog-title>
  {{ data.title['key'] || data.title | translate: data.title['param'] }}
</div>
<div
  *ngIf="data.message"
  mat-dialog-content
  [innerHTML]="
    data.message['key'] || data.message | translate: data.message['param']
  "
></div>
<div class="buttons">
  <button
    mat-raised-button
    *ngIf="data.cancelable"
    (click)="dialogRef.close(false)"
  >
    {{ data.cancelButtonText || 'common.actions.cancel' | translate }}
  </button>
  <button
    mat-raised-button
    [color]="data.isNegative ? 'warn' : 'primary'"
    (click)="dialogRef.close(true)"
  >
    {{ data.okButtonText || 'common.actions.ok' | translate }}
  </button>
</div>
